module.exports = __webpack_public_path__ + "img/quest_icon_0073_fire2.c2f0fc95.png";